<script lang="ts" setup>
export type LoadingWrapperAnimation = 'rotate' | 'fade-in'
export type LoadingWrapperColors = Colors | 'white'

export interface LoadingWrapperProps {
    color: LoadingWrapperColors
    animation?: LoadingWrapperAnimation
}

const props = withDefaults(defineProps<LoadingWrapperProps>(), {
    color: 'secondary',
    animation: 'rotate',
})
</script>
<template>
  <div
    class="loading-bar pe-none position-absolute z-index-5 start-0 top-0 end-0 bottom-0 d-flex align-items-center justify-content-center"
    :class="`loading-bar-${props.color}`"
  >
    <div
      class="loading-bar-icon"
      :class="`loading-bar-${props.animation}`"
    >
      <slot />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import './LoadingWrapper.scss';
</style>
